const envName = process.env.VUE_APP_NODE_ENV || process.env.NODE_ENV;

const defaultsByEnv = {
  dev: {
    apiBaseUrl: 'https://dev-api.comenow.com/api',
    appTitle: '[Dev]ComenowAdmin',
    stripeURL: 'https://dashboard.stripe.com/test',
  },
  development: {
    apiBaseUrl: 'https://dev-api.comenow.com/api',
    appTitle: '[Dev]ComenowAdmin',
    stripeURL: 'https://dashboard.stripe.com/test',
  },
  local: {
    apiBaseUrl: 'http://localhost:3300/api',
    appTitle: '[Local]ComenowAdmin',
    stripeURL: 'https://dashboard.stripe.com/test',
  },
  production: {
    apiBaseUrl: 'https://api.comenow.com/api',
    appTitle: 'ComenowAdmin',
    stripeURL: 'https://dashboard.stripe.com',
  },
};

const defaults = defaultsByEnv[envName] || defaultsByEnv.production;

export default {
  env: process.env.VUE_APP_NODE_ENV || envName,
  apiBaseUrl: process.env.VUE_APP_BASE_URL || defaults.apiBaseUrl,
  appTitle: process.env.VUE_APP_TITLE || defaults.appTitle,
  stripeURL: process.env.VUE_APP_STRIPE_URL || defaults.stripeURL,
};
